import { render, staticRenderFns } from "./ConfigurarAlertaForm.vue?vue&type=template&id=69ed2054&scoped=true&"
import script from "./ConfigurarAlertaForm.vue?vue&type=script&lang=ts&"
export * from "./ConfigurarAlertaForm.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurarAlertaForm.vue?vue&type=style&index=0&id=69ed2054&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ed2054",
  null
  
)

export default component.exports